module.exports = __webpack_public_path__ + "img/relsify_logo.1a010500.svg";